import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { Table } from "reactstrap";
import {
  getVersions,
  updateVersion,
  downloadBot,
} from "../../Redux/actions/processes";
import loader from "../../Assets/loaderTransaparent.gif";
import stringToDate from "../../Utilities/stringToDate";
import EllipsisWithTooltip from 'react-ellipsis-with-tooltip';
import "./index.css";


function Versions(props) {
  let { flow , offSet, getUpdateData} = props;

  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDowloading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [selectedId, setSelectedId] = useState();

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      let data = await getVersions(flow.id);
      setLoading(false);
      if (data.length > 0) {
        setVersions(data);
      }
    }
    fetchData();
  }, [flow]);

  const handleDownload = async (obj) => {
    let { bot_id, version_number ,id} = obj;
    setSelectedId(id);
    setDowloading(true);
    await downloadBot(bot_id, version_number, flow.name);
    setDowloading(false);
  };

  const handleClick = async (obj) => {
    let { bot_id, status, id } = obj;
    let payload = {
      bot_id,
      status,
      id,
    };
    setSelectedId(id);
    setProcessing(true);
    await updateVersion(payload);
    let data = await getVersions(flow.id);
    setProcessing(false);
    if (data.length > 0) {
      setVersions(data);
    }
    await getUpdateData(offSet);
  };

  if (loading) {
    return (
      <div className="main-content">
        <div style={{ textAlign: "center", marginTop: "15%" }}>
          <img src={loader} width="125" alt="loading"></img>
        </div>
      </div>
    );
  } else {
    return (
      <div className="main-content">
        <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li className="breadcrumb-item">
                          <NavLink to="/processes">
                            Action Flows 
                          </NavLink>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                            Versions 
                </li>
              </ol>
            </nav>
        </div>
        <div className="header-content">
          <label>{flow.name}</label>
        </div>
        <div className="content mt-3">
          <Table hover responsive className="responsive-table">
            <thead>
              <tr>
                <th>Version</th>
                <th>Published By</th>
                <th>Created At</th>
                <th>Rollback</th>
                <th>Download Flow</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {versions
                .sort((a, b) => a.id - b.id)
                .map((obj, ind) => {
                  return (
                    <tr key={ind}>
                      <td style={{ color: "#333333" }}>{obj.version_number}</td>
                      <td><EllipsisWithTooltip>{obj.email}</EllipsisWithTooltip></td>
                      <td><EllipsisWithTooltip>{stringToDate(obj.created_at)}</EllipsisWithTooltip></td>
                      <td style={{ paddingLeft: "2.5%" }}>
                        {obj.id === selectedId && processing ? (
                          <i
                            style={{ fontSize: "15px", color: "#02ce9d" }}
                            className="fas fa-circle-notch fa-spin"
                          ></i>
                        ) : obj.status === "ACTIVE" ? (
                          <i
                            style={{ color: "#02ce9d", fontSize: "25px" }}
                            className="fas fa-check-circle"
                          ></i>
                        ) : (
                          <i
                            className="fas fa-times-circle"
                            onClick={() => handleClick(obj)}
                          ></i>
                        )}
                      </td>
                      <td>
                        {obj.id === selectedId && downloading ? (
                          <i
                            style={{ fontSize: "15px", color: "#02ce9d" }}
                            className="fas fa-circle-notch fa-spin"
                          ></i>
                        ) : (
                          <i
                            className="fas fa-download"
                            style={{ fontSize: "18px" }}
                            onClick={() => handleDownload(obj)}
                          ></i>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, null)(Versions);
